// utils/Storage.ts (React Web)

import { logger, LOGS } from "../logs";
import { IStorage } from "./Storage.types";

class StorageImpl implements IStorage {
    getItem(key: string): string | null {
        try {
            return localStorage.getItem(key);
        } catch (error) {
            logger.error([LOGS.Storage], `Storage.getItem failed`, error);
            return null;
        }
    }

    setItem(key: string, value: string): void {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            logger.error([LOGS.Storage], `Storage.setItem failed`, error);
        }
    }

    removeItem(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            logger.error([LOGS.Storage], `Storage.removeItem failed`, error);
        }
    }

    getAllKeys(): string[] {
        try {
            return Object.keys(localStorage);
        } catch (error) {
            logger.error([LOGS.Storage], `Storage.getAllKeys failed`, error);
            return [];
        }
    }
}

export const Storage = new StorageImpl();
